import Immutable from 'seamless-immutable'
import * as actions from './actions'

export const initialState = Immutable.from({
  sessionId: '',
  features: {},
  attributes: {},
  loggerEnabled: false,
})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_OPTIMIZELY_SESSION_ID:
      return state.set('sessionId', payload)
    case actions.SET_OPTIMIZELY_ATTRIBUTES:
      return state.set('attributes', payload)
    case actions.SET_OPTIMIZELY_LOGGER_ENABLED:
      return state.set('loggerEnabled', payload)
    case actions.SET_OPTIMIZELY_ENABLED_FEATURES:
      return state.set('features', payload)
    default:
      return state
  }
}
